<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="con"><a id="page_viii"></a><a id="page_ix"></a><a href="#/xhtml/contents#con">Contributors</a></p>
<p class="Bodyflusha">Craig G. Bartholomew</p>
<p class="Body2">Director of the Kirby Laing Institute for Christian Ethics</p>
<p class="Body2">Tyndale House, Cambridge</p>
<p class="Bodyflush1a">Hans Boersma</p>
<p class="Body2">J. I. Packer Professor of Theology</p>
<p class="Body2">Regent College</p>
<p class="Bodyflush1a">S. A. Cummins</p>
<p class="Body2">Professor of Religious Studies</p>
<p class="Body2">Trinity Western University</p>
<p class="Bodyflush1a">Peter Enns</p>
<p class="Body2">Abram S. Clemens Professor of Biblical Studies</p>
<p class="Body2">Eastern University</p>
<p class="Bodyflush1a">Stephen E. Fowl</p>
<p class="Body2">Professor, Department of Theology</p>
<p class="Body2">Loyola University Maryland</p>
<p class="Bodyflush1a">Joel B. Green</p>
<p class="Body2">Provost, Dean of the School of Theology, and Professor of New Testament Interpretation</p>
<p class="Body2">Fuller Theological Seminary</p>
<p class="Bodyflush1a"><a id="page_x">Edith M. Humphrey</a></p><a id="page_x">
<p class="Body2">William F. Orr Professor of New Testament</p>
<p class="Body2">Pittsburgh Theological Seminary</p>
<p class="Bodyflush1a">Charles Raith II</p>
<p class="Body2">Vice President of Mission Integration</p>
<p class="Body2">Mercy Health System</p>
<p class="Bodyflush1a">Christopher R. Seitz</p>
<p class="Body2">Senior Research Professor</p>
<p class="Body2">Wycliffe College, University of Toronto</p>
<p class="Bodyflush1a">Robert W. Wall</p>
<p class="Body2">Paul T. Walls Professor of Scripture and Wesleyan Studies</p>
<p class="Body2">Seattle Pacific University and Seminary</p>
<p class="Bodyflush1a">Jens Zimmermann</p>
<p class="Body2">Canada Research Professor of Interpretation, Religion, and Culture, Trinity Western University, and Visiting Professor of Philosophy, Literature, and Theology, Regent College</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contributors.vue?c674118a